export { default } from "./src/logos";

export type { UniformLogosProps } from "./src/logos";
